import{post } from '@/utils/request';
import{filerequesturl } from '@/utils/baseUrl';


export async function getMDataMessage(param) {
    return post('/masterData/getMDataMessage',param,true)
}
export const filerequest_url=filerequesturl;
export async function getEditMessage(param) {
    return post('/masterData/getEditMessage',param,true)
}
export async function replaceMasterData(param) {
    return post('/masterData/replaceMasterData',param,true)
}
export async function saveMDRelation(param) {
    return post('/masterData/saveMDRelation',param,true)
}
export async function getMDataDetails(param) {
    return post('/masterData/getMDataDetails',param,true)
}